<template>
  <div class="b3-wrapper" ref="el" :class="{ 'is-visible': isVisible }">
    <section class="b3-section">

      <!-- ── Bloc Informations ───────────────────────── -->
      <div class="b3-block">
        <header class="b3-header">
          <span class="b3-eyebrow">{{ t('b3_eyebrow_find_us') }}</span>
          <h2 class="b3-titre">{{ t('b3_title_info') }} <em>{{ t('b3_title_info_em') }}</em></h2>
          <div class="b3-divider">
            <div class="b3-divider-line"></div>
            <div class="b3-divider-dot"></div>
            <div class="b3-divider-line"></div>
          </div>
        </header>

        <div class="b3-icons">
          <a
            href="https://www.facebook.com/profile.php?id=100063559811742"
            target="_blank"
            rel="noopener"
            class="b3-icon-pill"
          >
            <img src="@/icons/facebook.png" alt="Facebook Bamboo-Sushi Albi" />
            <span>{{ t('b3_follow_us') }}</span>
          </a>
          <div class="b3-icon-pill">
            <img src="@/icons/Image-vente-à-emporter.png" alt="Vente à emporter Bamboo-Sushi Albi" />
            <span>{{ t('b3_takeaway') }}</span>
          </div>
        </div>

        <div class="b3-infos">
          <div class="b3-vignette">
            <div class="b3-vignette-label">{{ t('b3_address_label') }}</div>
            <div class="b3-vignette-content">
              <p>40 Rue Docteur Laurent Camboulives</p>
              <p>81000 ALBI</p>
              <a href="tel:0563546609" class="b3-tel">05 63 54 66 09</a>
            </div>
          </div>

          <div class="b3-vignette">
            <div class="b3-vignette-label">{{ t('b3_hours_label') }}</div>
            <div class="b3-vignette-content">
              <p class="b3-days">{{ t('b3_days_open') }}</p>
              <div class="b3-horaire-row">
                <span>{{ t('b3_lunch') }}</span>
                <span>12h00 — 14h00</span>
              </div>
              <div class="b3-horaire-row">
                <span>{{ t('b3_dinner') }}</span>
                <span>19h00 — 22h00</span>
              </div>
              <p class="b3-alerte">{{ t('footer_alert_closed_lunch') }}</p>
              <p class="b3-note">{{ t('footer_note_hours') }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Bloc Avis Google ────────────────────────── -->
      <div class="b3-block">
        <header class="b3-header">
          <span class="b3-eyebrow">{{ t('b3_eyebrow_clients') }}</span>
          <h2 class="b3-titre">{{ t('b3_title_avis') }} <em>{{ t('b3_title_avis_em') }}</em></h2>
          <div class="b3-divider">
            <div class="b3-divider-line"></div>
            <div class="b3-divider-dot"></div>
            <div class="b3-divider-line"></div>
          </div>
        </header>

        <div class="b3-reviews-score-row">
          <span class="b3-google-g">
            <svg viewBox="0 0 24 24" width="28" height="28">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          </span>
          <div class="b3-reviews-meta">
            <div class="b3-score-line">
              <span class="b3-score-num">4,7</span>
              <span class="b3-stars">★★★★★</span>
            </div>
            <span class="b3-reviews-count">{{ t('b3_reviews_based_on') }}</span>
          </div>
        </div>

        <div class="b3-reviews-list">
          <div class="b3-review-card">
            <span class="b3-quote">"</span>
            <div class="b3-review-stars">★★★★★</div>
            <p class="b3-review-text">{{ t('b3_review1_text') }}</p>
            <div class="b3-review-footer">
              <div class="b3-avatar">LL</div>
              <div>
                <div class="b3-review-name">Laureilia Laude</div>
                <div class="b3-review-date">{{ t('b3_review1_date') }}</div>
              </div>
            </div>
          </div>

          <div class="b3-review-card">
            <span class="b3-quote">"</span>
            <div class="b3-review-stars">★★★★★</div>
            <p class="b3-review-text">{{ t('b3_review2_text') }}</p>
            <div class="b3-review-footer">
              <div class="b3-avatar">AM</div>
              <div>
                <div class="b3-review-name">Anhsar M.</div>
                <div class="b3-review-date">{{ t('b3_review2_date') }}</div>
              </div>
            </div>
          </div>

          <div class="b3-review-card">
            <span class="b3-quote">"</span>
            <div class="b3-review-stars">★★★★★</div>
            <p class="b3-review-text">{{ t('b3_review3_text') }}</p>
            <div class="b3-review-footer">
              <div class="b3-avatar">MS</div>
              <div>
                <div class="b3-review-name">Mehdi Simoud</div>
                <div class="b3-review-date">{{ t('b3_review3_date') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Google Maps ─────────────────────────────── -->
      <div class="b3-carte">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2873.624221510713!2d2.1438094154187524!3d43.92575344278145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ade80031a47d29%3A0xf538c0aa9a3994fd!2sBamboo%20Sushi!5e0!3m2!1sfr!2sfr!4v1635354201019!5m2!1sfr!2sfr"
          allowfullscreen=""
          loading="lazy"
          title="Localisation Bamboo Sushi Albi"
        ></iframe>
      </div>

    </section>
  </div>
</template>

<script setup>
import { useReveal } from '@/composables/useReveal'
import { useLocale } from '@/i18n'
const { el, isVisible } = useReveal()
const { t } = useLocale()
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital@0;1&display=swap');

/* ── Animation reveal ────────────────────────────── */
.b3-wrapper {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.75s ease, transform 0.75s ease;
}
.b3-wrapper.is-visible {
  opacity: 1;
  transform: translateY(0);
}

/* ── Wrapper & fond ──────────────────────────────── */
.b3-wrapper {
  width: 100%;
  align-self: stretch;
  background: linear-gradient(160deg, #1a1912 0%, #13130e 55%, #111110 100%);
  border-top: 1px solid rgba(200, 160, 85, 0.3);
  position: relative;
  overflow: hidden;
}

.b3-wrapper::before {
  content: '和';
  position: absolute;
  right: -2%;
  top: 50%;
  transform: translateY(-50%);
  font-size: clamp(280px, 35vw, 480px);
  color: rgba(200, 160, 85, 0.04);
  font-family: 'Hiragino Mincho Pro', 'Yu Mincho', 'MS Mincho', serif;
  line-height: 1;
  pointer-events: none;
  user-select: none;
  z-index: 0;
}

.b3-wrapper::after {
  content: '場';
  position: absolute;
  left: -3%;
  top: 15%;
  font-size: clamp(200px, 28vw, 380px);
  color: rgba(200, 160, 85, 0.03);
  font-family: 'Hiragino Mincho Pro', 'Yu Mincho', 'MS Mincho', serif;
  line-height: 1;
  pointer-events: none;
  user-select: none;
  z-index: 0;
}

.b3-section {
  width: 100%;
  padding: 5rem 1.5rem;
  background: transparent;
  text-align: center;
  position: relative;
  z-index: 1;
}

/* ── Blocs ───────────────────────────────────────── */
.b3-block {
  margin-bottom: 5rem;
}

/* ── En-tête ─────────────────────────────────────── */
.b3-header {
  margin-bottom: 3rem;
}

.b3-eyebrow {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: #8bbf30;
  margin-bottom: 1rem;
}

.b3-titre {
  font-family: 'Playfair Display', serif;
  font-size: 2.4rem;
  font-weight: 400;
  color: #ede8df;
  margin: 0 0 1.5rem;
  letter-spacing: 0.02em;
}

.b3-titre em {
  font-style: italic;
  color: #c8a055;
}

/* ── Séparateur doré ─────────────────────────────── */
.b3-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  max-width: 260px;
  margin: 0 auto;
}

.b3-divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(200, 160, 85, 0.6));
}

.b3-divider-line:last-child {
  background: linear-gradient(90deg, rgba(200, 160, 85, 0.6), transparent);
}

.b3-divider-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #c8a055;
  flex-shrink: 0;
}

/* ── Icônes pills ────────────────────────────────── */
.b3-icons {
  display: flex;
  justify-content: center;
  gap: 1.25rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.b3-icon-pill {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 2rem;
  background: transparent;
  border: 1px solid rgba(200, 160, 85, 0.25);
  border-radius: 6px;
  text-decoration: none;
  color: #c8c2b8;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  transition: border-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}

.b3-icon-pill:hover {
  border-color: rgba(200, 160, 85, 0.6);
  color: #c8a055;
}

.b3-icon-pill img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

/* ── Vignettes infos ─────────────────────────────── */
.b3-infos {
  display: flex;
  justify-content: center;
  gap: 0;
  max-width: 900px;
  margin: 0 auto;
  border: 1px solid rgba(200, 160, 85, 0.18);
  border-radius: 4px;
  overflow: hidden;
  flex-wrap: wrap;
}

.b3-vignette {
  flex: 1 1 300px;
  padding: 2.5rem 2.75rem;
  text-align: left;
  border-right: 1px solid rgba(200, 160, 85, 0.15);
}

.b3-vignette:last-child {
  border-right: none;
}

.b3-vignette-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #8bbf30;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.b3-vignette-content p {
  font-size: 0.9rem;
  color: #c0bbb2;
  line-height: 1.8;
  margin: 0 0 0.25rem;
  font-weight: 300;
}

.b3-days {
  font-weight: 600 !important;
  color: #ddd8cf !important;
  margin-bottom: 0.75rem !important;
}

.b3-horaire-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.88rem;
  color: #c0bbb2;
  padding: 0.2rem 0;
  font-weight: 300;
}

.b3-alerte {
  font-style: italic;
  color: #c0876a !important;
  font-size: 0.83rem !important;
  margin-top: 0.75rem !important;
}

.b3-note {
  font-style: italic;
  color: #706a60 !important;
  font-size: 0.78rem !important;
  margin-top: 0.4rem !important;
  line-height: 1.6 !important;
}

.b3-tel {
  display: inline-block;
  margin-top: 1.25rem;
  font-size: 0.95rem;
  font-weight: 400;
  color: #c8a055;
  text-decoration: none;
  letter-spacing: 0.15em;
  transition: opacity 0.2s ease;
}

.b3-tel:hover {
  opacity: 0.75;
}

/* ── Score Google ────────────────────────────────── */
.b3-reviews-score-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  margin-bottom: 2.5rem;
}

.b3-google-g {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.b3-reviews-meta {
  text-align: left;
}

.b3-score-line {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.b3-score-num {
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  color: #ede8df;
}

.b3-stars {
  color: #FBBC05;
  font-size: 1.1rem;
  letter-spacing: 2px;
}

.b3-reviews-count {
  font-size: 0.72rem;
  color: #706a60;
  letter-spacing: 0.08em;
}

/* ── Cartes avis ─────────────────────────────────── */
.b3-reviews-list {
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 960px;
  margin: 0 auto;
}

.b3-review-card {
  position: relative;
  flex: 1 1 250px;
  max-width: 300px;
  background: transparent;
  border: 1px solid rgba(200, 160, 85, 0.18);
  border-radius: 4px;
  padding: 1.5rem 1.5rem 1.25rem;
  text-align: left;
  transition: border-color 0.3s ease;
}

.b3-review-card:hover {
  border-color: rgba(200, 160, 85, 0.4);
}

.b3-quote {
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  font-family: 'Playfair Display', serif;
  font-size: 3rem;
  color: rgba(200, 160, 85, 0.25);
  line-height: 1;
  pointer-events: none;
}

.b3-review-stars {
  color: #FBBC05;
  font-size: 0.85rem;
  letter-spacing: 2px;
  margin-bottom: 0.75rem;
}

.b3-review-text {
  font-size: 0.85rem;
  color: #a09a90;
  line-height: 1.75;
  font-style: italic;
  font-weight: 300;
  margin: 0 0 1.25rem;
}

.b3-review-footer {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.b3-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #4a6e1a;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.b3-review-name {
  font-size: 0.8rem;
  color: #c8c2b8;
  font-weight: 600;
}

.b3-review-date {
  font-size: 0.7rem;
  color: #605a52;
  margin-top: 0.1rem;
}

/* ── Google Maps ─────────────────────────────────── */
.b3-carte {
  max-width: 1000px;
  margin: 0 auto;
  border: 1px solid rgba(200, 160, 85, 0.2);
  border-radius: 4px;
  overflow: hidden;
  filter: grayscale(0.2) contrast(1.05);
  transition: filter 0.3s ease;
}

.b3-carte:hover {
  filter: grayscale(0) contrast(1);
}

.b3-carte iframe {
  display: block;
  width: 100%;
  height: 420px;
  border: 0;
}

/* ── Responsive ──────────────────────────────────── */
@media (max-width: 768px) {
  .b3-titre {
    font-size: 1.8rem;
  }

  .b3-vignette {
    border-right: none;
    border-bottom: 1px solid rgba(200, 160, 85, 0.15);
    max-width: 100%;
  }

  .b3-vignette:last-child {
    border-bottom: none;
  }

  .b3-review-card {
    max-width: 100%;
  }

  .b3-carte iframe {
    height: 300px;
  }
}
</style>
